import { css } from "@compiled/react";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation, {
    ExistingUser
} from "@/components/signup/site-activation";
import { RovoDevAgentsLogo } from "@/components/signup/utils";

import { PrivacyPolicy, WelcomeBackHeading } from "../../components";

export const LoggedInRovoDevStandardExistingSitesUser = () => {
    return (
        <SignupBackgroundLayout
            theme="green"
            ProductLogo={<RovoDevAgentsLogo />}
        >
            <h1 css={headerCss}>
                <WelcomeBackHeading />
            </h1>
            <SiteActivation
                ExistingUser={
                    <ExistingUser PrivacyPolicy={<PrivacyPolicy />} />
                }
                WeekOneUser={null}
                ManagedUser={null}
            />
        </SignupBackgroundLayout>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});
